import { connect } from 'react-redux';
import { selectActiveVenue } from 'selectors/general';

import Decagon from './Decagon';

const mapStateToProps = state => ({
  activeVenue: selectActiveVenue(state),
});

export default connect(mapStateToProps)(Decagon);
